import { AlertCircle } from 'lucide-react'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Skeleton } from '@/components/ui/skeleton'
import { MemberActivityInsights } from './components/MemberActivityInsights'
import { useLatestApplication } from '@/features/membership/hooks/useLatestApplication'

export function MemberInsightsPage() {
  const { latestApplication, query } = useLatestApplication()

  const isLoading = query.isPending && !query.data
  const hasError = query.isError
  const errorMessage =
    query.error instanceof Error
      ? query.error.message
      : 'We could not load your membership applications.'

  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <p className="text-sm font-medium text-primary">Membership analytics</p>
        <h1 className="text-3xl font-semibold tracking-tight">Usage insights</h1>
        <p className="text-muted-foreground text-sm max-w-2xl">
          Explore how you interact with institute resources. Filters update the breakdowns, trends, and highlights in real time.
        </p>
      </div>

      {hasError && (
        <Alert variant="destructive">
          <AlertCircle className="size-4" aria-hidden />
          <AlertTitle>Unable to load membership applications</AlertTitle>
          <AlertDescription>{errorMessage}</AlertDescription>
        </Alert>
      )}

      {isLoading ? (
        <Skeleton className="h-[420px] w-full rounded-xl border border-dashed border-primary/20" />
      ) : (
        <MemberActivityInsights latestApplication={latestApplication} />
      )}
    </div>
  )
}
